import { Inputs, ParametersEnum } from '../../../types';
import { getProjectConfigurationParameters } from './get-project-configuration-parameters';
import { getFacetsValues } from './get-facets-values';
import { facetsIds } from '../../../const';

export const getProjectUpdatedCustomEventPayload = (inputsData: Inputs) => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);
  const facets = [];
  if (inputsData.doorType) {
    facets.push({
      id: facetsIds.DOOR_TYPE,
      values: getFacetsValues(ParametersEnum.doorType, inputsData.doorType),
    });
  }
  if (inputsData.colour) {
    facets.push({
      id: facetsIds.COLOUR,
      values: getFacetsValues(ParametersEnum.colour, inputsData.colour),
    });
  }
  if (inputsData.forWetRooms) {
    facets.push({
      id: facetsIds.FOR_WET_ROOMS,
      values: getFacetsValues(ParametersEnum.forWetRooms, inputsData.forWetRooms),
    });
  }

  return {
    projectConfigurationParameters,
    facets,
  };
};
